import Formsy from 'formsy-react'
import React, { Component } from 'react'
import { Button, Confirm, Container, Dropdown, Grid, Header, Icon, Label, Pagination, Search, Segment, Table } from 'semantic-ui-react'
import { getSellerPaymentMethods, getSellerRadius, getSellerSingleBuyerRequestsList, getSubscribedSellerDetails, getSubscriptionPaymentDetails, searchSubscribedSeller, sellerSubNinetyDayPayments } from 'services/Manager';
import moment from 'moment';
import { priceDisplay } from 'helpers/price';
import './SubscriptionSearchContainer.less'
import PaymentCard from 'components/PaymentCard/PaymentCard';
import GoogleMapReact from 'google-map-react';
import Config from 'Config';
import Marker from '../../components/GMaps/Marker';
import sellerSubStatus from 'constants/SellerSubscriptionStatus';
import { useParams } from 'react-router';
import { isDisputeResolvedStatus } from 'constants/stripeDisputeStatus';
import _ from 'lodash';
import mapUtilityMethods from 'utils/mapUtilityMethods';
import subStatus from 'constants/SellerSubscriptionStatus';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { saveSellerDetail } from 'services/Seller';
import { checkManagerAuthorization } from 'helpers/authorization';
import featuresList from '../../constants/FeaturesList';
import { connect } from 'react-redux';

const inititalState = {
    sellers: [],
    selectedSeller: {},
    searchingSellers: false,
    searchSellerPhrase: '',
    sellerID: 0,
    sellerSubscriptions: [],
    sellerDetail: {},
    prioritizedForJob: false,
    paymentMethods: [],
    mapCenter: { lat: 39.8097343, lng: -98.5556199 },
    zoomLevel: 10,
    singleBuyerRequests: [],
    noOfSectionForSingleBuyerRequests: 4,
    noOfSingleBuyerRequestsPerSection: 5,
    acceptedRequestsCurrentPage: 1,
    acceptedRequestCount: 0,
    showLeadPaymentFailedButton: false,
    isLeadPaymentFailedConfirmOpen: false,
    isSuccessMessageShown: false,
    leadPaymentFailedEnabled: false
}

const ACCEPTED_REQUEST_PAGE_SIZE = 25;
const noticationTimeout = 2000;

function SubscriptionSearchContainerWrapper(props) {
    // create this wrapper function component b/c class component did not support hooks (useParams)
    const { sellerID } = useParams()
    return <SubscriptionSearchContainer {...props} match={{ params: { sellerID: sellerID } }} />
}

class SubscriptionSearchContainer extends Component {

    static defaultProps = {
        USCenter: {
            lat: 39.8097343,
            lng: -98.5556199
        },
        zoom: 1
    };

    constructor(props) {
        super(props);
        this.state = inititalState;
    }

    componentDidMount() {
        const sellerIDParam = this.props.match.params.sellerID ? this.props.match.params.sellerID : '';
        if (sellerIDParam) {
            this.directPopulateSellerData(sellerIDParam);
        }
        this.setState({ leadPaymentFailedEnabled: checkManagerAuthorization(featuresList.LEAD_PAYMENT_FAILED, this.props.currentUser) })
    }

    createMapOptions = (maps) => {
        return {
            fullscreenControl: false,
        }
    }

    directPopulateSellerData = async (sellerID) => {
        await this.onSellerSelect(undefined, { result: { id: sellerID, title: "" } }, true)
    }

    onSearchSellerChange = (e, { value }) => {
        this.setState({ searchSellerPhrase: value, searchingSellers: true });
        if (this.searchSellerTimer)
            clearTimeout(this.searchSellerTimer);

        this.searchSellerTimer = setTimeout(() => {
            if (this.state.searchSellerPhrase.length > 0) {
                searchSubscribedSeller(this.state.searchSellerPhrase).then((response) => {
                    if (response.resStatus === 200) {
                        let sellers = [];
                        response.data.map((seller) => {
                            sellers.push({ id: seller.sellerID, title: seller.name, seoName: seller.seoName });
                        })

                        this.setState({ sellers: sellers });
                    }

                    this.setState({ searchingSellers: false });

                });
            }
            else {
                this.setState({ sellers: [], selectedSeller: {}, searchingSellers: false });
            }
        }, 600)
    }

    onSellerSelect = async (e, { result }, setSellerName = false) => {
        this.setState({ sellerID: result.id, searchSellerPhrase: result.title });
        const sellerSubsResponse = await getSubscribedSellerDetails(result.id);


        if (sellerSubsResponse.resStatus == 200) {
            const firstNode = _.first(sellerSubsResponse.data);
            const sellerData = {
                sellerID: firstNode.sellerID,
                sellerName: firstNode.sellerName,
                email: firstNode.email,
                cellPhone: firstNode.cellPhone,
                thirtyDayRevenue: firstNode.thirtyDayRevenue,
                sixtyDayRevenue: firstNode.sixtyDayRevenue,
                ninetyDayRevenue: firstNode.ninetyDayRevenue,
                allTimeRevenue: firstNode.allTimeRevenue,
                prioritizedForJob: firstNode.prioritizedForJob,
                lat: firstNode.lat,
                lon: firstNode.lon,
                serviceRadius: firstNode.serviceRadius,
                acceptingJobs: firstNode.acceptingJobs,
                acceptingJobsLastUpdatedOn: firstNode.acceptingJobsLastUpdatedOn,
                leadPaymentFailed: firstNode.leadPaymentFailed
            }

            let sellerName = "";
            if (setSellerName) {
                sellerName = firstNode.sellerName;
            }

            let subscriptions = sellerSubsResponse.data;

            let categoryRadiusResponse = await getSellerRadius(result.id);
            let selectedCategoryIDForRadius = 0;
            if (categoryRadiusResponse.resStatus == 200) {
                let categoryRadius = categoryRadiusResponse.data;

                let categoryRadiusOptions = _.map(categoryRadius, cr => {
                    return {
                        key: cr.categoryID,
                        text: cr.categoryName,
                        value: cr.categoryID
                    }
                });
                selectedCategoryIDForRadius = categoryRadius[0].categoryID;
                this.setState({ categoryRadiusOptions: categoryRadiusOptions, selectedCategoryIDForRadius: categoryRadius[0].categoryID, selectedCategoryRadius: categoryRadius[0].serviceRadius, categoryRadius: categoryRadius }, () => {

                });
            }

            await this.getAcceptedRequests(selectedCategoryIDForRadius);
            /*const paymentResponses = await Promise.all(subscriptions.map(s => sellerSubNinetyDayPayments(s.sellerSubID)));

            

            for(let res of paymentResponses){
                if(res && res.resStatus == 200){
                    const [subscription] = _.filter(subscriptions, s => s.sellerSubID == res.data.sellerSubID);
                    
                    if(subscription){
                        subscription.ninetyDayPayments = res.data.ninetyDayPayments;
                        subscription.ninetyDayRefunds = res.data.ninetyDayRefunds;
                        subscription.ninetyDayDisputes = res.data.ninetyDayDisputes;
                    }
                }
            }*/

            const paymentDetailsResponses = await Promise.all(subscriptions.map(s => getSubscriptionPaymentDetails(s.sellerID, s.sellerSubID)));

            for (let pdRes of paymentDetailsResponses) {
                if (pdRes && pdRes.resStatus == 200) {
                    const [subscription] = _.filter(subscriptions, s => {
                        if (pdRes.data && pdRes.data.length > 0) {
                            return s.sellerSubID == pdRes.data[0].sellerSubID;
                        }
                        return false;
                    });

                    if (subscription) {
                        subscription.payments = pdRes.data;

                    }
                }
            }

            this.setState({
                sellerDetail: sellerData,
                sellerSubscriptions: subscriptions,
                mapCenter: { lat: +sellerData.lat, lng: +sellerData.lon },
                searchSellerPhrase: sellerName,
                showLeadPaymentFailedButton: sellerData.leadPaymentFailed
            });

            const paymentMethodsRes = await getSellerPaymentMethods(result.id);
            if (paymentMethodsRes.resStatus == 200) {
                this.setState({ paymentMethods: paymentMethodsRes.data });
            }


        }
    }

    getAcceptedRequests = async (selectedCategoryID) => {

        const singleBuyerRequestsRes = await getSellerSingleBuyerRequestsList(this.state.sellerID, 60, ACCEPTED_REQUEST_PAGE_SIZE, this.state.acceptedRequestsCurrentPage)
        if (singleBuyerRequestsRes.resStatus == 200) {
            let totalRequest = [...singleBuyerRequestsRes.data.acceptedRequests];

            this.setState({ singleBuyerRequests: totalRequest, acceptedRequestCount: singleBuyerRequestsRes.data.count, noOfSectionForSingleBuyerRequests: Math.ceil(totalRequest.length / this.state.noOfSingleBuyerRequestsPerSection) });

            if (selectedCategoryID) {
                const selectedCategoryRequests = _.filter(totalRequest, r => r.categoryID == selectedCategoryID);
                this.setState({ selectedCategoryRequests: selectedCategoryRequests });
            }
        }
    }

    removePriority = async () => {
        const res = await prioritizeSellerForJob(this.state.sellerDetail.sellerID, false);
        if (res.resStatus == 200) {
            this.setState({ sellerDetail: { ...this.state.sellerDetail, prioritizedForJob: false } })
        }
    }

    applyPriority = async () => {
        const res = await prioritizeSellerForJob(this.state.sellerDetail.sellerID, true);
        if (res.resStatus == 200) {
            this.setState({ sellerDetail: { ...this.state.sellerDetail, prioritizedForJob: true } })
        }
    }

    handleRequestIDClick = (requestURL) => {
        const win = window.open(requestURL);
        win.focus();
    }

    onAcceptedRequestPageChange = (e, data) => {
        this.setState({ acceptedRequestsCurrentPage: data.activePage }, async () => {
            await this.getAcceptedRequests(this.state.selectedCategoryIDForRadius);
        });

    }

    getSBRRequestSections = () => {
        let sections = [];
        let noOfSingleBuyerRequestsPerSection = this.state.noOfSingleBuyerRequestsPerSection;
        for (let index = 0; index < this.state.noOfSectionForSingleBuyerRequests; index++) {
            let requestsList = [...this.state.singleBuyerRequests];
            <>
                {
                    sections.push(
                        <Grid.Column tablet={16} computer={8} widescreen={4} key={`section-col-${index}`} className={"request-list-section"}>
                            {
                                requestsList.splice(index * noOfSingleBuyerRequestsPerSection, noOfSingleBuyerRequestsPerSection).map((sbr) => {
                                    return (
                                        <div className={"request-list-box"} onClick={() => this.handleRequestIDClick(sbr.requestURL)}>
                                            <div className={"items-container"}>
                                                {/* <div className={"item"}>
                                                    <b>
                                                        {"ID : "}
                                                    </b>
                                                    {sbr.singleBuyerRequestID}
                                                </div> */}
                                                <div className={"item"}>
                                                    <b>
                                                        {"Price : "}
                                                    </b>
                                                    {priceDisplay(sbr.price)}
                                                </div>
                                                <div className={"item"}>
                                                    <b>
                                                        {"Accepted : "}
                                                    </b>
                                                    {moment(sbr.acceptedOn).format('MMM DD YYYY')}
                                                </div>
                                                <div className={"item"}>
                                                    <b>
                                                        {"Commission : "}
                                                    </b>
                                                    {priceDisplay(sbr.commissionCharged)}
                                                </div>
                                                <div className={"item"}>
                                                    <b>
                                                        {"Dispute Amount : "}
                                                    </b>
                                                    {priceDisplay(sbr.disputeAmount)}
                                                </div>
                                                <div className={"item"}>
                                                    <b>
                                                        {"Status : "}
                                                    </b>
                                                    {sbr.disputeAmount ? isDisputeResolvedStatus(sbr.stripeDisputeStatus) ? "Dispute Resolved" : "In Dispute" : sbr.commissionPaymentStatus}

                                                </div>
                                                <div className={"item quick-info"}>
                                                    <div>
                                                        <b>
                                                            {"Quick Info: "}
                                                        </b>
                                                    </div>

                                                    <div className='content' title={sbr.quickInfo}>{sbr.quickInfo}</div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </Grid.Column>
                    )
                }
            </>
        }
        return sections;
    }

    apiIsLoaded = (map, maps) => {
        try {
            let circle;
            if (google && this.state.sellerDetail) {
                circle = new google.maps.Circle({
                    strokeColor: "#FF0000",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: "#FF0000",
                    fillOpacity: 0.3,
                    map,
                    center: { lat: Number(this.state.sellerDetail.lat), lng: Number(this.state.sellerDetail.lon) },
                    radius: mapUtilityMethods.convertMilesIntoMeters(this.state.selectedCategoryRadius ? this.state.selectedCategoryRadius : 0)
                });

                /*var sellerBaseMarker = new google.maps.Marker({
                    icon: marker_green,
                    position: { lat: Number(this.state.sellerDetail.lat), lng: Number(this.state.sellerDetail.lon) },
                    
                    
                });
    
                sellerBaseMarker.setMap(map);*/


            }


        } catch (e) {
            console.log("Error in apiIsLoaded().")
            console.log(e);
        }
    };

    onRadiusCategoryChange = (e, data) => {
        const totalRequest = this.state.singleBuyerRequests;
        const selectedCategoryID = data.value;
        const selectedCategoryRequests = _.filter(totalRequest, r => r.categoryID == selectedCategoryID);

        const categoryRadius = this.state.categoryRadius;
        const selectedCategoryRadius = _.find(categoryRadius, c => c.categoryID == selectedCategoryID);
        this.setState({ selectedCategoryIDForRadius: 0 }, () => {
            this.setState({ selectedCategoryRequests: selectedCategoryRequests, selectedCategoryIDForRadius: selectedCategoryID, selectedCategoryRadius: selectedCategoryRadius.serviceRadius });
        })

    }

    onLeadPaymentFailedSubmit = async () => {

        this.setState({ isLeadPaymentFailedConfirmOpen: false })

        const res = await saveSellerDetail(this.state.sellerDetail.sellerID, { leadPaymentFailed: false });

        if (res && res.resStatus == 200) {
            NotificationManager.success("Lead Payment Failed update successfully.", '', noticationTimeout);
            this.setState({ showLeadPaymentFailedButton: false })
        }
        else {
            NotificationManager.error("Fail to update Lead Payment Failed check", '', noticationTimeout);
        }
    }

    render() {
        return (
            <>
                <NotificationContainer />
                <Container fluid className="subscription-container">
                    <div className="main-page-panel">
                        <div className="content-panel">
                            <div className="mobile-header">
                                <div className="main-heading">
                                    Subscriptions
                                </div>
                            </div>
                            <Segment className="filter-segment">
                                <Formsy onValidSubmit={this.onSearch}>
                                    <Grid>
                                        <Grid.Row>
                                            <Grid.Column width={16}>
                                                <Header>Search Seller</Header>
                                                <Search
                                                    fluid
                                                    className="seller-search search-box"
                                                    loading={this.state.searchingSellers}
                                                    minCharacters={1}
                                                    onSearchChange={this.onSearchSellerChange}
                                                    results={this.state.sellers}
                                                    onResultSelect={this.onSellerSelect}
                                                    value={this.state.searchSellerPhrase}

                                                />
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </Formsy>
                            </Segment>


                            <Segment className="seller-details">
                                {!_.isEmpty(this.state.sellerSubscriptions) &&

                                    <>
                                        <div className="seller-details-container">
                                            <div className="seller-details-container-header">
                                                {this.state.sellerDetail.sellerName}
                                                {
                                                    (this.state.leadPaymentFailedEnabled && this.state.showLeadPaymentFailedButton) ? <Button primary onClick={() => this.setState({ isLeadPaymentFailedConfirmOpen: true })}>Card Good To Go </Button>
                                                        : <></>
                                                }
                                                {/* {this.state.sellerDetail.prioritizedForJob == true && <>&nbsp;&nbsp;<Label size="big" as='a'>Prioritized For Job<Icon name='delete' onClick={this.removePriority}/></Label></>}
                                            {this.state.sellerDetail.prioritizedForJob == false && <>&nbsp;&nbsp;<a className='lnk-prioritize' onClick={this.applyPriority}>Prioritize</a></>} */}
                                            </div>
                                            <div className="seller-details-container-content">
                                                <div className="seller-details-container-content-box">
                                                    <p>Email</p>
                                                    <h4>{this.state.sellerDetail.email}</h4>
                                                </div>
                                                <div className="seller-details-container-content-box">
                                                    <p>Phone</p>
                                                    <h4>{this.state.sellerDetail.cellPhone}</h4>
                                                </div>
                                                {/*<div className="seller-details-container-content-box">
                                                <p>30 Day Revenue</p>
                                                <h4>{this.state.sellerDetail.thirtyDayRevenue ? `${priceDisplay(this.state.sellerDetail.thirtyDayRevenue)}` : '-'}</h4>
                                            </div>
                                            <div className="seller-details-container-content-box">
                                                <p>60 Day Revenue</p>
                                                <h4>{this.state.sellerDetail.sixtyDayRevenue ? `${priceDisplay(this.state.sellerDetail.sixtyDayRevenue)}` : '-'}</h4>
                                            </div>
                                            <div className="seller-details-container-content-box">
                                                <p>90 Day Revenue</p>
                                                <h4>{this.state.sellerDetail.ninetyDayRevenue ? `${priceDisplay(this.state.sellerDetail.ninetyDayRevenue)}` : '-'}</h4>
                                            </div>
                                            <div className="seller-details-container-content-box">
                                                <p>All Time Revenue</p>
                                                <h4>{this.state.sellerDetail.allTimeRevenue ? `${priceDisplay(this.state.sellerDetail.allTimeRevenue)}` : '-'}</h4>
                                    </div>*/}
                                                <div className="seller-details-container-content-box">
                                                    <p>Accepting Jobs</p>
                                                    <h4>{this.state.sellerDetail.acceptingJobs ? 'Yes' : 'No'}</h4>
                                                </div>
                                                <div className="seller-details-container-content-box">
                                                    <p>Accepting Jobs Last Updated On</p>
                                                    <h4>{this.state.sellerDetail.acceptingJobsLastUpdatedOn ? moment(this.state.sellerDetail.acceptingJobsLastUpdatedOn).format('DD MMM YYYY hh:mm A') : '-'}</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <Header size='huge'>Subscriptions</Header>
                                        {_.map(this.state.sellerSubscriptions, ss => {
                                            return <div className="seller-details-container">
                                                <div className="seller-details-container-header">
                                                    {`${ss.categoryName}`}
                                                </div>
                                                <div className="seller-details-container-content">
                                                    <div className="seller-details-container-content-box">
                                                        <p>Plan</p>
                                                        <h4>{ss.planName}</h4>
                                                    </div>
                                                    <div className="seller-details-container-content-box">
                                                        <p>Plan Price</p>
                                                        <h4>${ss.price}</h4>
                                                    </div>
                                                    <div className="seller-details-container-content-box">
                                                        <p>Status</p>
                                                        <h4 className={ss.subStatus == sellerSubStatus.ACTIVE ? 'active' :
                                                            ss.subStatus == sellerSubStatus.CANCELED ? 'cancelled' :
                                                                ss.subStatus == sellerSubStatus.PENDING_ACTIVATION ? 'pending-activation' :
                                                                    ''}>{ss.subStatus}</h4>
                                                    </div>
                                                    <div className="seller-details-container-content-box">
                                                        <p>Start</p>
                                                        <h4>{moment(ss.start).format('DD MMM YYYY')}</h4>
                                                    </div>
                                                    <div className="seller-details-container-content-box">
                                                        <p>Lead Fee</p>
                                                        <h4>
                                                            {ss.commission > 0 ? `${ss.commission}%` : ss.referralFee > 0 ? `$${ss.referralFee}` : '$0'}

                                                        </h4>
                                                    </div>
                                                    {/*<div className="seller-details-container-content-box">
                                                    <p>Last Payment Date</p>
                                                    <h4>{ss.lastPaymentDate ? moment(ss.lastPaymentDate).format('DD MMM YYYY') : '-'}</h4>
                                                </div>
                                                <div className="seller-details-container-content-box">
                                                    <p>Last Payment Amount</p>
                                                    <h4>{ss.lastPaymentAmount ? `${priceDisplay(ss.lastPaymentAmount)}` : '-'}</h4>
                                                </div>*/}

                                                    {/*<div className="seller-details-container-content-box">
                                                    <p>90 Day Payments</p>
                                                    <h4>{ss.ninetyDayPayments ? `${priceDisplay(ss.ninetyDayPayments)}` : '-'}</h4>
                                                </div>

                                                <div className="seller-details-container-content-box">
                                                    <p>90 Day Refunds</p>
                                                    <h4>{ss.ninetyDayRefunds ? `${priceDisplay(ss.ninetyDayRefunds)}` : '-'}</h4>
                                                </div>

                                                <div className="seller-details-container-content-box">
                                                    <p>90 Day Disputes</p>
                                                    <h4>{ss.ninetyDayDisputes ? `${priceDisplay(ss.ninetyDayDisputes)}` : '-'}</h4>
                                                </div>*/}
                                                </div>
                                                <div className="seller-details-container-payments-header">
                                                    Payments
                                                </div>
                                                <div className="seller-details-container-content">
                                                    <Table>
                                                        <Table.Header>
                                                            <Table.Row>
                                                                <Table.HeaderCell>
                                                                    Charged Amount
                                                                </Table.HeaderCell>
                                                                <Table.HeaderCell>
                                                                    Billed Amount
                                                                </Table.HeaderCell>
                                                                <Table.HeaderCell>
                                                                    Payment Status
                                                                </Table.HeaderCell>
                                                                <Table.HeaderCell>
                                                                    Invoice Date
                                                                </Table.HeaderCell>
                                                                <Table.HeaderCell>
                                                                    Paid On
                                                                </Table.HeaderCell>
                                                                <Table.HeaderCell>
                                                                    Refund Amount
                                                                </Table.HeaderCell>
                                                                <Table.HeaderCell>
                                                                    Dispute Amount
                                                                </Table.HeaderCell>
                                                                <Table.HeaderCell>
                                                                    Leads
                                                                </Table.HeaderCell>
                                                            </Table.Row>
                                                        </Table.Header>
                                                        <Table.Body>
                                                            {
                                                                ss.payments && ss.payments.map(p => {
                                                                    return <Table.Row>
                                                                        <Table.Cell>
                                                                            {priceDisplay(p.chargedAmount)}
                                                                        </Table.Cell>
                                                                        <Table.Cell>
                                                                            {priceDisplay(p.billedAmount)}
                                                                        </Table.Cell>
                                                                        <Table.Cell>
                                                                            {p.disputeAmount ? isDisputeResolvedStatus(p.stripeDisputeStatus) ? "Dispute Resolved" : "In Dispute" : p.paymentStatus}
                                                                        </Table.Cell>
                                                                        <Table.Cell>
                                                                            {moment(p.invoiceDate).format('DD MMM YYYY')}
                                                                        </Table.Cell>
                                                                        <Table.Cell>
                                                                            {moment(p.paidOn).format('DD MMM YYYY HH:mm')}
                                                                        </Table.Cell>
                                                                        <Table.Cell>
                                                                            {priceDisplay(p.refundAmount)}
                                                                        </Table.Cell>
                                                                        <Table.Cell>
                                                                            {priceDisplay(p.disputeAmount)}
                                                                        </Table.Cell>
                                                                        <Table.Cell>
                                                                            {p.leadCount}
                                                                        </Table.Cell>
                                                                    </Table.Row>
                                                                })
                                                            }
                                                            {
                                                                (!ss.payments || ss.payments.length == 0) && <Table.Row>
                                                                    <Table.Cell colspan={5}>
                                                                        No payments found
                                                                    </Table.Cell>

                                                                </Table.Row>
                                                            }

                                                        </Table.Body>
                                                    </Table>
                                                </div>
                                            </div>
                                        })}

                                        <Header size='huge'>All Accepted Jobs</Header>
                                        {
                                            <>
                                                <div className="seller-details-container">
                                                    <div className={"sbr-list-container"}>
                                                        <Grid>
                                                            <Grid.Row>
                                                                <Grid.Column width={16}>
                                                                    <Table selectable>
                                                                        <Table.Header>
                                                                            <Table.Row>
                                                                                <Table.HeaderCell>
                                                                                    Customer
                                                                                </Table.HeaderCell>
                                                                                {/*<Table.HeaderCell>
                                                                                Price
                                    </Table.HeaderCell>*/}
                                                                                <Table.HeaderCell>
                                                                                    Accepted On
                                                                                </Table.HeaderCell>
                                                                                <Table.HeaderCell>
                                                                                    Commission
                                                                                </Table.HeaderCell>
                                                                                <Table.HeaderCell>
                                                                                    Dispute Amount
                                                                                </Table.HeaderCell>
                                                                                <Table.HeaderCell>
                                                                                    Status
                                                                                </Table.HeaderCell>
                                                                                <Table.HeaderCell>
                                                                                    Quick Info
                                                                                </Table.HeaderCell>
                                                                            </Table.Row>
                                                                        </Table.Header>
                                                                        <Table.Body>
                                                                            {this.state.singleBuyerRequests.map((sbr) => {
                                                                                return <Table.Row style={{ cursor: 'pointer' }} onClick={() => this.handleRequestIDClick(sbr.requestURL)}>
                                                                                    <Table.Cell>
                                                                                        {sbr.buyerFirstName}
                                                                                    </Table.Cell>
                                                                                    {/*<Table.Cell>
                                                                                    {priceDisplay(sbr.price)}
                                                                        </Table.Cell>*/}
                                                                                    <Table.Cell>
                                                                                        {moment(sbr.acceptedOn).format('MMM DD YYYY')}
                                                                                    </Table.Cell>
                                                                                    <Table.Cell>
                                                                                        {priceDisplay(sbr.commissionCharged)}
                                                                                    </Table.Cell>
                                                                                    <Table.Cell>
                                                                                        {priceDisplay(sbr.disputeAmount)}
                                                                                    </Table.Cell>
                                                                                    <Table.Cell>
                                                                                        {sbr.disputeAmount ? isDisputeResolvedStatus(sbr.stripeDisputeStatus) ? "Dispute Resolved" : "In Dispute" : sbr.commissionPaymentStatus}
                                                                                    </Table.Cell>
                                                                                    <Table.Cell>
                                                                                        {sbr.quickInfo}
                                                                                    </Table.Cell>

                                                                                </Table.Row>
                                                                            })}
                                                                            {
                                                                                _.isEmpty(this.state.singleBuyerRequests) && <Table.Row>
                                                                                    <Table.Cell colspan={6}>
                                                                                        No records found
                                                                                    </Table.Cell>
                                                                                </Table.Row>
                                                                            }
                                                                        </Table.Body>
                                                                    </Table>
                                                                    {!_.isEmpty(this.state.singleBuyerRequests) &&
                                                                        <Pagination defaultActivePage={this.state.acceptedRequestsCurrentPage}
                                                                            totalPages={Math.ceil(this.state.acceptedRequestCount / ACCEPTED_REQUEST_PAGE_SIZE)}
                                                                            onPageChange={this.onAcceptedRequestPageChange}
                                                                        />}
                                                                </Grid.Column>

                                                                {
                                                                    //this.getSBRRequestSections()
                                                                }
                                                            </Grid.Row>
                                                        </Grid>
                                                    </div>
                                                </div>
                                            </>
                                        }

                                        {this.state.paymentMethods && this.state.paymentMethods.length ? <>
                                            <Header size='huge'>Payment Methods</Header>

                                            <div className="seller-details-container">

                                                {this.state.paymentMethods.map(pm =>
                                                    <div className='seller-payment-method-container'>
                                                        <PaymentCard {...pm.card} />
                                                    </div>
                                                )}
                                            </div>
                                        </> : ""
                                        }

                                        <Header size='huge'>Map</Header>

                                        <div className="seller-details-container" style={{ height: '500px' }}>

                                            {this.state.sellerDetail && this.state.sellerDetail.sellerID == this.state.sellerID &&
                                                <>
                                                    <Dropdown
                                                        placeholder='Select Category'
                                                        selection
                                                        options={this.state.categoryRadiusOptions}
                                                        value={this.state.selectedCategoryIDForRadius}
                                                        onChange={this.onRadiusCategoryChange}
                                                        style={{ marginTop: '10px', marginBottom: '10px', marginLeft: '10px' }}
                                                    >

                                                    </Dropdown>
                                                    {this.state.selectedCategoryIDForRadius && <GoogleMapReact
                                                        bootstrapURLKeys={{ key: Config.maps.key, language: 'en', region: 'us' }}
                                                        defaultZoom={this.props.zoom}
                                                        zoom={this.state.zoomLevel}
                                                        center={this.state.mapCenter}
                                                        options={this.createMapOptions}
                                                        defaultCenter={this.props.USCenter}
                                                        onGoogleApiLoaded={({ map, maps }) => this.apiIsLoaded(map, maps)}
                                                    >
                                                        <Marker trial={false} subscribed={true}
                                                            lat={this.state.sellerDetail.lat} lng={this.state.sellerDetail.lon} title={this.state.sellerDetail.sellerName}
                                                            phone={this.state.sellerDetail.cellPhone} sellerid={this.state.sellerDetail.sellerID} />

                                                        {this.state.selectedCategoryRequests && this.state.selectedCategoryRequests.length > 0 &&
                                                            this.state.selectedCategoryRequests.map((sbr) => {

                                                                return <Marker trial={false} subscribed={true}
                                                                    lat={+sbr.lat} lng={+sbr.lon} title={sbr.buyerFirstName + (_.isEmpty(sbr.buyerLastName) ? "" : " " + sbr.buyerLastName)}
                                                                    status={subStatus.ACTIVE}
                                                                //phone={this.state.sellerDetail.cellPhone} sellerid={this.state.sellerDetail.sellerID} 
                                                                />
                                                            })
                                                        }
                                                    </GoogleMapReact>}
                                                </>
                                            }
                                        </div>
                                    </>
                                }

                                {_.isEmpty(this.state.sellerSubscriptions) && <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={16}>
                                            <Header size="large">No seller selected</Header>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                                }



                                {/*<Table celled striped>
                            
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Email</Table.HeaderCell>
                                        <Table.HeaderCell>Business</Table.HeaderCell>
                                        <Table.HeaderCell>Phone</Table.HeaderCell>
                                        <Table.HeaderCell>Category</Table.HeaderCell>
                                        <Table.HeaderCell>Plan</Table.HeaderCell>
                                        <Table.HeaderCell>Status</Table.HeaderCell>
                                        <Table.HeaderCell>Start</Table.HeaderCell>
                                        <Table.HeaderCell>Price</Table.HeaderCell>
                                        <Table.HeaderCell>Commision %</Table.HeaderCell>
                                        <Table.HeaderCell>Referral</Table.HeaderCell>
                                        <Table.HeaderCell>Last Payment Date</Table.HeaderCell>
                                        <Table.HeaderCell>Next Payment Date</Table.HeaderCell>
                                        <Table.HeaderCell>Next Payment</Table.HeaderCell>
                                        <Table.HeaderCell>Last Payment</Table.HeaderCell>
                                        <Table.HeaderCell>Last Bid Accepted</Table.HeaderCell>
                                        <Table.HeaderCell>30 days revenue</Table.HeaderCell>
                                        <Table.HeaderCell>60 days revenue</Table.HeaderCell>                                      
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {
                                        !_.isEmpty(this.state.seller) && <Table.Row>
                                                <Table.Cell>
                                                    {this.state.seller.email}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {this.state.seller.sellerName}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {this.state.seller.cellPhone}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {this.state.seller.categoryName}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {this.state.seller.planName}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {this.state.seller.sellerStatus}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {moment(this.state.seller.start).format('DD MMM YYYY')}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {priceDisplay(this.state.seller.price)}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {this.state.seller.commission ? `${this.state.seller.commission}%` : '-'}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {this.state.seller.referralFee ? `${priceDisplay(this.state.seller.referralFee)}` : '-'}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {moment(this.state.seller.lastPaymentDate).format('DD MMM YYYY')}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {this.state.seller.nextPaymentDate ? moment(this.state.seller.nextPaymentDate).format('DD MMM YYYY') : '-'}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {this.state.seller.nextPaymentAmount ? `${priceDisplay(this.state.seller.nextPaymentAmount)}` : '-'}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {this.state.seller.lastPaymentAmount ? `${priceDisplay(this.state.seller.lastPaymentAmount)}` : '-'}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {this.state.seller.lastBidAcceptedDate ? moment(this.state.seller.lastBidAcceptedDate).format('DD MMM YYYY') : '-'}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {this.state.seller.thirtyDayRevenue ? `${priceDisplay(this.state.seller.thirtyDayRevenue)}` : '-'}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {this.state.seller.sixtyDayRevenue ? `${priceDisplay(this.state.seller.sixtyDayRevenue)}` : '-'}
                                                </Table.Cell>
                                            </Table.Row>
                                        
                                    }
                                    {
                                        _.isEmpty(this.state.seller) && <Table.Row>
                                            <Table.Cell colspan={16}>
                                                No record found
                                            </Table.Cell>
                                        </Table.Row>
                                    }
                                </Table.Body>
                                </Table>*/}
                                <Confirm
                                    open={this.state.isLeadPaymentFailedConfirmOpen}
                                    onClose={() => this.setState({ isLeadPaymentFailedConfirmOpen: false })}
                                    header='Update lead payment failed'
                                    content='Are you sure you want to update lead payment failed check ?'
                                    onCancel={() => this.setState({ isLeadPaymentFailedConfirmOpen: false })}
                                    onConfirm={this.onLeadPaymentFailedSubmit}
                                    className='subscription-cancel-confirm'
                                />
                            </Segment>

                        </div>
                    </div>
                </Container>
            </>
        )
    }
}

function mapStateToProps({ auth }) {
    //Whatever is returned from this function will end up
    // as props inside of this container component
    return {
        currentUser: auth.currentUser,
    }
}

export default connect(mapStateToProps)(SubscriptionSearchContainerWrapper);


